<template>
  <el-table :data="simCardDataTable" stripe style="width: 100%" ref="simCardDataTable" border v-loading="listLoading">
    <!--                <af-table-column type="selection" width="30"></af-table-column>-->
    <af-table-column prop="operatorType.message" label="营业商"></af-table-column>
    <af-table-column prop="packageType" label="套餐"></af-table-column>
    <af-table-column prop="flow" label="流量(Mb)"></af-table-column>
    <af-table-column prop="validityPeriod" label="有效期"></af-table-column>
    <af-table-column prop="cardNo" label="卡号"></af-table-column>
    <af-table-column prop="stationName" label="充电站"></af-table-column>
    <af-table-column prop="pileName" label="充电桩"></af-table-column>
    <af-table-column prop="operatorName" label="运营商"></af-table-column>
    <af-table-column prop="payType.message" label="付费类型"></af-table-column>

    <af-table-column label="操作" width="240px">
      <template slot-scope="scope">
        <el-button size="mini" plain @click="simCardDetail(scope.$index, scope.row)">详情</el-button>
        <el-button size="mini" @click="simCardEdit(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:simCard:updateSimCard'])">编辑
        </el-button>
        <el-button size="mini" type="danger" @click="simCardDelete(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:simCard:deleteSimCard'])">删除
        </el-button>
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "list",
    data(){
      return{
      }
    },
    props:{
      simCardDataTable:{},
      listLoading:false,
    },
    methods:{
      simCardEdit(index,row){
        this.$emit("simCardEdit",index,row)
      },
      simCardDelete(index,row){
        this.$emit("simCardDelete",index,row)
      },
      simCardDetail(index,row){
        this.$emit("simCardDetail",index,row)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/simCardManager/list.vue